import React from "react";
import icon from "../../assets/Slip.svg";

export default function SlippageIcon({ size }) {
  return <img src={icon} width={size} />;
}
